export enum PlatformType {
	android = 'ANDROID',
	ios = 'IOS',
	blink = 'BLINK',
	edge = 'EDGE',
	firefox = 'FIREFOX',
	safari = 'SAFARI',
	trident = 'TRIDENT',
	webkit = 'WEBKIT',
	browser = 'isBrowser',
}

export abstract class PlatformDetectorProvider {
	types: typeof PlatformType = PlatformType;
	abstract isOneOfPlatform(...types: Array<PlatformType>): boolean;
	abstract detectPlatformTypes(): Array<PlatformType>;
	abstract isMobile(): boolean;
	abstract isWin(): boolean;
}
